module.exports = __webpack_public_path__ + "static/media/apti_mvp.69a09c0a.jpg";